<!-- CONTENIDO -->
<div class="grid grid-cols-1 md:grid-cols-12 gap-3 p-3">
    <!-- PERFIL -->
    <div class="hidden md:flex md:col-span-2 flex-col p-2 items-center">
        <div class="flex flex-col items-center gap-2">
            <img
                [src]="
                    imagenPreview ||
                    'data:image/svg+xml;utf8,\
          <svg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 128 128%22>\
            <circle cx=%2264%22 cy=%2248%22 r=%2228%22 fill=%22%23d1d5db%22/>\
            <rect x=%2220%22 y=%2282%22 width=%2288%22 height=%2234%22 rx=%2217%22 fill=%22%23e5e7eb%22/>\
          </svg>'
                "
                alt="Foto de Perfil"
                class="rounded-full w-32 h-32 object-cover border-4 border-gray-300 shadow-lg"
            />

            <input id="adjunto" type="file" class="hidden" #fileInput accept="image/*" (change)="onFileSelected($event)" />

            <button type="button" pButton icon="pi pi-upload" class="p-button-secondary p-button-sm" (click)="fileInput.click()" pTooltip="Subir imagen" tooltipPosition="bottom" aria-label="Subir imagen de perfil"></button>
        </div>

        <h3 class="text-xl font-semibold text-gray-800 dark:text-slate-100 mt-2">
            {{ form.get('nombre')?.value || 'Usuario' }}
        </h3>
        <span class="text-gray-600 dark:text-slate-300">
            {{ form.get('usuario')?.value || 'Sin nombre de usuario' }}
        </span>
    </div>

    <!-- FORMULARIO -->
    <div class="md:col-span-7 flex flex-col">
        <div class="form-guidance-banner mb-3">
            <div class="guidance-title">Antes de guardar</div>
            <div class="guidance-body">Los campos con <strong>*</strong> son obligatorios. Los campos marcados como opcionales pueden completarse luego.</div>
            <div class="guidance-body">Abra cada sección de permisos, revise las opciones y marque los accesos que necesite el nuevo usuario.</div>
            <div class="guidance-chips">
                <span class="chip chip-required">Obligatorio *</span>
                <span class="chip chip-optional">Opcional</span>
            </div>
        </div>

        <form [formGroup]="form" (ngSubmit)="update()" class="grid grid-cols-1 md:grid-cols-3 gap-4">
            @if (!esEdicion) {
                <div class="md:col-span-3">
                    <div class="email-switch-card">
                        <div>
                            <div class="email-switch-title">Correo de nuevo usuario</div>
                            <div class="email-switch-help">Defina si se envía el mail con credenciales al finalizar el alta.</div>
                        </div>

                        <label class="mail-switch" aria-label="Enviar correo de nuevo usuario">
                            <input type="checkbox" [checked]="sendWelcomeEmail" (change)="sendWelcomeEmail = $any($event.target).checked" />
                            <span class="mail-switch-slider"></span>
                            <span class="mail-switch-label">{{ sendWelcomeEmail ? 'Enviar' : 'No enviar' }}</span>
                        </label>
                    </div>
                </div>
            }

            <div class="flex flex-col gap-2">
                <div class="field-wrapper mt-2">
                    <label for="usuario">Nickname *</label>
                    <input id="usuario" autocomplete="off" pInputText formControlName="usuario" placeholder="Ingrese el usuario" [ngClass]="{ 'p-invalid': form.get('usuario')?.invalid && form.get('usuario')?.touched }" />
                    <small class="p-error" [class.field-error-visible]="form.get('usuario')?.invalid && form.get('usuario')?.touched">
                        @if (form.get('usuario')?.errors?.['required']) {
                            El nickname es requerido.
                        }
                        @if (form.get('usuario')?.errors?.['minlength']) {
                            El nickname debe tener al menos 3 caracteres.
                        }
                        @if (!form.get('usuario')?.invalid || !form.get('usuario')?.touched) {
                            &nbsp;
                        }
                    </small>
                </div>

                <div class="field-wrapper mt-2">
                    <label for="clave">Contraseña *</label>
                    <input id="clave" autocomplete="new-password" pInputText type="password" formControlName="clave" placeholder="Ingrese su contraseña" [ngClass]="{ 'p-invalid': form.get('clave')?.invalid && form.get('clave')?.touched }" />
                    <small class="p-error" [class.field-error-visible]="form.get('clave')?.invalid && form.get('clave')?.touched">
                        @if (form.get('clave')?.errors?.['required']) {
                            La contraseña es requerida.
                        }
                        @if (!form.get('clave')?.invalid || !form.get('clave')?.touched) {
                            &nbsp;
                        }
                    </small>
                </div>

                <div class="field-wrapper mt-2">
                    <label for="dni">DNI (opcional)</label>
                    <p-inputNumber id="dni" formControlName="dni" placeholder="Ingrese su DNI" [ngClass]="{ 'p-invalid': form.get('dni')?.invalid && form.get('dni')?.touched }" />
                    <small class="p-error" [class.field-error-visible]="form.get('dni')?.invalid && form.get('dni')?.touched">
                        @if (form.get('dni')?.errors?.['min']) {
                            Si lo completa, el DNI debe ser mayor a 0.
                        }
                        @if (!form.get('dni')?.invalid || !form.get('dni')?.touched) {
                            &nbsp;
                        }
                    </small>
                </div>

                <div class="hidden md:block">
                    <div class="field-wrapper mt-2">
                        <label for="telefono">Teléfono (opcional)</label>
                        <input id="telefono" pInputText formControlName="telefono" placeholder="Ingrese un número de teléfono" />
                    </div>
                </div>

                <div class="hidden md:block">
                    <div class="field-wrapper mt-2">
                        <label for="legajo">Legajo (opcional)</label>
                        <input id="legajo" pInputText formControlName="legajo" placeholder="Ingrese número de legajo" />
                    </div>
                </div>

                <div class="hidden md:block">
                    <div class="field-wrapper mt-2">
                        <label for="fecha_nacimiento">Fecha de nacimiento (opcional)</label>
                        <p-datepicker
                            appendTo="body"
                            [iconDisplay]="'input'"
                            [showIcon]="true"
                            id="fecha_nacimiento"
                            placeholder="dd/mm/aaaa"
                            formControlName="fecha_nacimiento"
                            dateFormat="dd/mm/yy"
                            class="w-full"
                            [style]="{ width: '100%' }"
                            [inputStyle]="{ width: '100%' }"
                        />
                    </div>
                </div>
            </div>

            <div class="flex flex-col gap-2">
                <div class="field-wrapper mt-2">
                    <label for="nombre">Nombre *</label>
                    <input id="nombre" pInputText formControlName="nombre" placeholder="Ingrese el nombre" [ngClass]="{ 'p-invalid': form.get('nombre')?.invalid && form.get('nombre')?.touched }" />
                    <small class="p-error" [class.field-error-visible]="form.get('nombre')?.invalid && form.get('nombre')?.touched">
                        @if (form.get('nombre')?.errors?.['required']) {
                            El nombre es requerido.
                        }
                        @if (!form.get('nombre')?.invalid || !form.get('nombre')?.touched) {
                            &nbsp;
                        }
                    </small>
                </div>

                <div class="hidden md:block">
                    <div class="field-wrapper mt-2">
                        <label for="linea">Línea</label>
                        <p-select optionLabel="nombre" id="linea" formControlName="linea" [options]="opcionesSelect.lineas" placeholder="Seleccione" />
                    </div>
                </div>

                <div class="field-wrapper mt-3">
                    <label for="descripcion">Descripción *</label>
                    <p-select optionLabel="descripcion" id="descripcion" formControlName="descripcion" [options]="opcionesSelect.descripciones" placeholder="Seleccione" />
                </div>

                <div class="hidden md:block">
                    <div class="field-wrapper mt-2">
                        <label for="direccion">Dirección (opcional)</label>
                        <input id="direccion" pInputText formControlName="direccion" placeholder="Ingrese su domicilio" />
                    </div>
                </div>

                <div class="hidden md:block">
                    <div class="field-wrapper mt-2">
                        <label for="genero">Género (opcional)</label>
                        <p-select optionLabel="nombre" id="genero" formControlName="genero" [options]="opcionesSelect.generos" placeholder="Seleccione" />
                    </div>
                </div>

                <div class="hidden md:block">
                    <div class="field-wrapper mt-2">
                        <label for="fecha_ingreso">Fecha de ingreso</label>
                        <p-datepicker
                            class="w-full"
                            appendTo="body"
                            [iconDisplay]="'input'"
                            [showIcon]="true"
                            id="fecha_ingreso"
                            placeholder="dd/mm/aaaa"
                            formControlName="fecha_ingreso"
                            dateFormat="dd/mm/yy"
                            [style]="{ width: '100%' }"
                            [inputStyle]="{ width: '100%' }"
                        />
                    </div>
                </div>
            </div>

            <div class="flex flex-col gap-2">
                <div class="field-wrapper mt-2">
                    <label for="apellido">Apellido *</label>
                    <input id="apellido" pInputText formControlName="apellido" placeholder="Ingrese el apellido" [ngClass]="{ 'p-invalid': form.get('apellido')?.invalid && form.get('apellido')?.touched }" />
                    <small class="p-error" [class.field-error-visible]="form.get('apellido')?.invalid && form.get('apellido')?.touched">
                        @if (form.get('apellido')?.errors?.['required']) {
                            El apellido es requerido.
                        }
                        @if (!form.get('apellido')?.invalid || !form.get('apellido')?.touched) {
                            &nbsp;
                        }
                    </small>
                </div>

                <div class="field-wrapper mt-2">
                    <label for="correo">Correo *</label>
                    <input id="correo" pInputText formControlName="correo" placeholder="ejemplo@blister.com" [ngClass]="{ 'p-invalid': form.get('correo')?.invalid && form.get('correo')?.touched }" aria-describedby="correo-help" />
                    <small id="correo-help" class="p-error" [class.field-error-visible]="form.get('correo')?.invalid && form.get('correo')?.touched">
                        @if (form.get('correo')?.errors?.['required']) {
                            El correo es requerido.
                        }
                        @if (form.get('correo')?.errors?.['email']) {
                            Formato de correo inválido.
                        }
                        @if (!form.get('correo')?.invalid || !form.get('correo')?.touched) {
                            &nbsp;
                        }
                    </small>
                </div>

                <div class="field-wrapper mt-2">
                    <label for="empresa">Empresa *</label>
                    <p-select optionLabel="nombre" id="empresa" formControlName="empresa" [options]="opcionesSelect.empresas" placeholder="Seleccione" />
                </div>

                <div class="hidden md:block">
                    <div class="field-wrapper mt-2">
                        <label for="nacionalidad">Nacionalidad (opcional)</label>
                        <p-select optionLabel="nombre" id="nacionalidad" formControlName="nacionalidad" [options]="opcionesSelect.nacionalidades" placeholder="Seleccione" />
                    </div>
                </div>

                <div class="hidden md:block">
                    <div class="field-wrapper mt-2">
                        <label for="cuil">CUIL (opcional)</label>
                        <input id="cuil" pInputText formControlName="cuil" placeholder="Ingrese un CUIL (11 caracteres máximo)" maxlength="11" />
                    </div>
                </div>
            </div>

            <div class="md:col-span-3">
                <div class="permissions-banner mb-2">
                    <i class="pi pi-info-circle"></i>
                    <div>
                        <div class="permissions-banner-title">Permisos del sistema</div>
                        <div class="permissions-banner-text">Debe seleccionar al menos un permiso para guardar el usuario.</div>
                    </div>
                    <span class="permissions-counter">{{ form.get('randomClaims')?.value?.length || 0 }} seleccionados</span>
                </div>

                <!-- Selector de permisos -->
                @for (grupoGeneral of opcionesSelect.grupos; track grupoGeneral.nombre) {
                    <div class="border border-gray-200 dark:border-zinc-700 p-2 rounded-lg my-3 bg-white dark:bg-[#202024ef] text-gray-800 dark:text-slate-100 shadow-sm">
                        <div class="flex justify-between items-center cursor-pointer" (click)="icon.classList.toggle('rotate-180'); grupos.classList.toggle('show')">
                            <label class="block cursor-pointer text-gray-700 dark:text-slate-100">Permisos {{ grupoGeneral.nombre }}</label>
                            <i #icon class="pi pi-angle-down transition-all duration-200"></i>
                        </div>

                        <div class="hide" #grupos>
                            <div>
                                <hr class="my-2 border-gray-200 dark:border-zinc-700" />
                                @for (grupo of grupoGeneral.grupos; track grupo.subOption) {
                                    <small class="pl-2 text-gray-600 dark:text-slate-300">
                                        <b>{{ grupo.subOption }}</b>
                                    </small>

                                    <div class="grid grid-cols-2 md:grid-cols-3 gap-3 mt-2">
                                        @for (item of grupo.options; track item.value) {
                                            <button
                                                type="button"
                                                class="w-full h-full px-2 py-2 rounded-md border transition-colors duration-150"
                                                (click)="toggleGrupo(grupoGeneral.nombre, grupo.subOption, item.value)"
                                                [ngClass]="
                                                    checkButtonClaim(grupoGeneral.nombre, grupo.subOption, item.value)
                                                        ? 'bg-primary-400/80 text-white border-primary'
                                                        : 'bg-white dark:bg-[#202024ef] text-primary dark:text-primary border-primary hover:bg-primary-400/80 hover:text-white'
                                                "
                                                [pTooltip]="item.description"
                                                tooltipPosition="top"
                                            >
                                                {{ item.label }}
                                            </button>
                                        }
                                    </div>
                                    <br />
                                }
                            </div>
                        </div>
                    </div>
                }
                <!-- Fin Selector de permisos -->

                @if (hasRrhhAprobadorClaim) {
                    <div class="rrhh-aprobacion-panel mt-4" [formGroup]="form">
                        <div class="rrhh-aprobacion-panel__header">
                            <div>
                                <div class="rrhh-aprobacion-panel__eyebrow">RRHH</div>
                                <h4 class="rrhh-aprobacion-panel__title">Tipos de solicitud habilitados</h4>
                                <p class="rrhh-aprobacion-panel__description">Este permiso requiere al menos un tipo de solicitud asignado para que el usuario pueda aprobar movimientos de RRHH.</p>
                            </div>
                            <div class="rrhh-aprobacion-panel__badge">{{ rrhhAprobacionTipoPlanillaIds.length }} seleccionados</div>
                        </div>

                        <div class="rrhh-aprobacion-panel__grid">
                            @for (tipo of rrhhAprobacionTipos; track tipo.id) {
                                <button
                                    type="button"
                                    class="rrhh-aprobacion-chip"
                                    [class.is-active]="isRrhhAprobacionTipoSelected(tipo.id)"
                                    (click)="toggleRrhhAprobacionTipo(tipo.id)"
                                >
                                    <span class="rrhh-aprobacion-chip__dot"></span>
                                    <span class="rrhh-aprobacion-chip__label">{{ $any(tipo).nombre_tipo || tipo.name || tipo.id }}</span>
                                </button>
                            }
                        </div>

                        <small class="p-error rrhh-aprobacion-error" [class.field-error-visible]="form.get('rrhhAprobacionTipoPlanillaIds')?.touched && !hasRrhhAprobacionTipos">
                            Seleccione al menos un tipo de solicitud.
                        </small>
                    </div>
                }

                <small class="p-error" [class.field-error-visible]="form.get('randomClaims')?.invalid && form.get('randomClaims')?.touched">
                    @if (form.get('randomClaims')?.errors?.['required']) {
                        Debe seleccionar al menos un permiso para continuar.
                    }
                    @if (!form.get('randomClaims')?.invalid || !form.get('randomClaims')?.touched) {
                        &nbsp;
                    }
                </small>
            </div>



            <div class="md:col-span-3 flex justify-end gap-2 mt-4">
                @if (!esEdicion) {
                    <button pButton type="button" label="Crear Usuario" icon="pi pi-save" class="p-button-success" [disabled]="form.invalid || !hasSelectedClaims()" (click)="crearUsuario()"></button>
                } @else {
                    <button pButton type="button" label="Cancelar" class="p-button-secondary" (click)="cancelar()"></button>
                    <button pButton type="button" label="Guardar" [disabled]="form.invalid || !hasSelectedClaims()" (click)="update()"></button>
                }
            </div>
        </form>
    </div>

    <!-- DATOS CONDUCTOR (columna derecha) -->
    <div class="md:col-span-3 flex flex-col">
        @if (isConductorSelected) {
            <div class="border-2 border-primary rounded-xl p-5 bg-white dark:bg-slate-900 shadow-sm" [formGroup]="conductorForm">
                <div class="flex items-center gap-2 mb-5">
                    <i class="pi pi-car text-primary text-lg"></i>
                    <h3 class="text-base font-semibold text-primary">Datos de Conductor</h3>
                </div>

                <div class="flex flex-col gap-4">
                    <div class="field-wrapper">
                        <label for="conductor_nro_licencia">Número de Licencia *</label>
                        <p-inputNumber id="conductor_nro_licencia" formControlName="nro_licencia" placeholder="Número de licencia" class="w-full"
                            [ngClass]="{ 'p-invalid': conductorForm.get('nro_licencia')?.invalid && conductorForm.get('nro_licencia')?.touched }" />
                        <small class="p-error" [class.field-error-visible]="conductorForm.get('nro_licencia')?.invalid && conductorForm.get('nro_licencia')?.touched">
                            @if (conductorForm.get('nro_licencia')?.errors?.['required']) { Requerido. }
                            @else if (conductorForm.get('nro_licencia')?.errors?.['max']) { El número supera el valor máximo permitido (9.999.999.999). }
                            @else { &nbsp; }
                        </small>
                    </div>

                    <div class="field-wrapper">
                        <label for="conductor_licencia_tipo">Tipo de Licencia *</label>
                        <p-select [showClear]="true" id="conductor_licencia_tipo" formControlName="licencia_tipo"
                            [options]="conductorOptions.tipoLicencia" placeholder="Seleccione" appendTo="body" optionLabel="siglas" class="w-full"
                            [ngClass]="{ 'p-invalid': conductorForm.get('licencia_tipo')?.invalid && conductorForm.get('licencia_tipo')?.touched }" />
                        <small class="p-error" [class.field-error-visible]="conductorForm.get('licencia_tipo')?.invalid && conductorForm.get('licencia_tipo')?.touched">
                            @if (conductorForm.get('licencia_tipo')?.errors?.['required']) { Requerido. } @else { &nbsp; }
                        </small>
                    </div>

                    <div class="field-wrapper">
                        <label for="conductor_vencimiento">Vencimiento de Licencia *</label>
                        <p-datepicker class="w-full" appendTo="body" [iconDisplay]="'input'" [showIcon]="true"
                            id="conductor_vencimiento" formControlName="vencimiento_licencia"
                            dateFormat="dd/mm/yy" placeholder="dd/mm/aaaa"
                            [style]="{ width: '100%' }" [inputStyle]="{ width: '100%' }"
                            [ngClass]="{ 'p-invalid': conductorForm.get('vencimiento_licencia')?.invalid && conductorForm.get('vencimiento_licencia')?.touched }" />
                        <small class="p-error" [class.field-error-visible]="conductorForm.get('vencimiento_licencia')?.invalid && conductorForm.get('vencimiento_licencia')?.touched">
                            @if (conductorForm.get('vencimiento_licencia')?.errors?.['required']) { Requerida. } @else { &nbsp; }
                        </small>
                    </div>

                    <div class="field-wrapper">
                        <label for="conductor_llave">Llave GPS</label>
                        <input id="conductor_llave" pInputText formControlName="llave" placeholder="Código de llave" class="w-full" />
                    </div>

                    <div class="field-wrapper">
                        <label for="conductor_tipo">Tipo de Conductor</label>
                        <p-select [showClear]="true" id="conductor_tipo" formControlName="tipo"
                            optionLabel="siglas" [options]="conductorOptions.tipoConducir" placeholder="Seleccione" appendTo="body" class="w-full" />
                    </div>

                    <div class="field-wrapper">
                        <label for="conductor_md_nivel">MD Nivel</label>
                        <p-select [showClear]="true" id="conductor_md_nivel" formControlName="md_nivel"
                            optionLabel="siglas" [options]="conductorOptions.nivelMd" appendTo="body" placeholder="Seleccione" class="w-full" />
                    </div>
                </div>
            </div>
        } @else {
            <!-- Placeholder vacío cuando no es conductor -->
            <div class="flex flex-col items-center justify-center h-full gap-3 text-gray-400 dark:text-gray-600 select-none py-10">
                <i class="pi pi-car text-5xl opacity-20"></i>
                <span class="text-sm text-center">Los datos de conductor aparecerán aquí cuando se asigne el permiso correspondiente.</span>
            </div>
        }

        <!-- Los @for vacíos preservan la referencia a las variables del TS sin renderizar nada -->
        <ng-container>
            @for (menu of menuHSE; track $index) {}
            @for (menu of menuAprobador; track $index) {}
            @for (menu of menuConductor; track $index) {}
            @for (menu of menuGuardia; track $index) {}
        </ng-container>
    </div>
</div>
